import { ReservedResourcePhase } from 'src/api/api.generated'
import { compareDates } from 'src/utils/date'

type BaseRO = {
  start: Date
  end: Date
  phase: ReservedResourcePhase
}

type BaseRR<RO extends BaseRO> = {
  resourceOccupancies: RO[]
}

export function getCurrentResourceOccupancy<RR extends BaseRR<RO>, RO extends BaseRO>(hotelDate: Date, reservedResource: RR): RO | null {
  const occupancies = reservedResource.resourceOccupancies
  if (occupancies.length <= 1) {
    return occupancies[0] || null
  }
  const sortedOccupancies = [...occupancies].sort((a, b) => +a.start - +b.start)

  const hotelDateOccupancies = sortedOccupancies.filter((o) => compareDates(o.start, hotelDate) <= 0 && compareDates(hotelDate, o.end) <= 0)
  //hotel date between min start and max end
  if (hotelDateOccupancies.length > 0) {
    //only one occupancy or change room not yet done
    if (
      hotelDateOccupancies.length === 1 ||
      (hotelDateOccupancies[0].phase === ReservedResourcePhase.CHECKIN && hotelDateOccupancies[hotelDateOccupancies.length - 1].phase === ReservedResourcePhase.RESERVATION)
    ) {
      return hotelDateOccupancies[0]
    }
    return hotelDateOccupancies[hotelDateOccupancies.length - 1]
  }

  const lastOccupancyIndex = sortedOccupancies.length - 1
  if (compareDates(hotelDate, sortedOccupancies[lastOccupancyIndex].end) > 0) {
    return sortedOccupancies[lastOccupancyIndex]
  }

  return sortedOccupancies[0]
}
